/* eslint-disable @typescript-eslint/no-explicit-any */
export const openFilePicker = ({ block, editor, }) => {
    if (block.type !== 'image' &&
        block.type !== 'video' &&
        block.type !== 'audio' &&
        block.type !== 'lottie') {
        return;
    }
    const config = editor.schema.blockSchema[block.type];
    const accept = config.isFileBlock && config.fileBlockAccept?.length
        ? config.fileBlockAccept.join(',')
        : '*/*';
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = accept;
    input.onchange = async (event) => {
        const target = event.target;
        const file = target?.files?.[0];
        if (!file) {
            return;
        }
        const result = await editor.uploadFile?.(file);
        editor.updateBlock(block, {
            ...(typeof result === 'object' ? result : {}),
        });
    };
    input.click();
};
//# sourceMappingURL=openFilePicker.js.map